import React, { Fragment } from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Row, Button, FormGroup, Label, Input, Alert, Modal,
    ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import Navbarh from '../navbar/Navbar';
import '../estilos.css';
import * as IoIcons from 'react-icons/io';
import Pagination from "react-js-pagination";
import Moment from 'moment';
import classnames from 'classnames';
import Produccion from './Produccion';
import Inspeccion from './Inspeccion';
import usePProduccion from '../../hooks/usePProduccion';
import Recuperacion from '../calidad/Recuperacion';
import QrReader from "react-qr-reader";
import BarcodeReader from 'react-barcode-reader';
import PlaneacionB from '../planeacion/PlaneacionB';
import DetallesProduccion from './DetallesProduccion';
import PProduccionGen from './PProduccionGen';
import AlmacenProduccion from './AlmacenProduccion';
import ProduccionPC from './ProduccionPC';


function PProduccion() {
    //Declaración de variables        
    const { verpproducciones, pproducciones, formType, pPlanProduccion, activeTab, editar, ppproduccion,
        verpplaneacion, sumProduccionp, sumICiclos, fechaPlaneacion, inputList, isDisabled, textPQR,
        toggle1, handleError, handleScan, clicConQR, setFechaPlaneacion, setInputList, handleInputChange,
        handleRemoveClick, cancelarpProduccion, managePProduccion } = usePProduccion();

    return (
        <>
            <Navbarh />
            {(pproducciones === true || verpproducciones === true) && (
                <>
                    <Row>
                        <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <IoIcons.IoIosBusiness className="iconoc floatleft" onClick={() => { toggle1('1'); }} />
                            <h3 >{formType}</h3>
                        </div>
                    </Row>
                    <div className="conteiner2">
                        <Fragment>
                            <div>
                                <Nav tabs>
                                    <NavItem className={(pPlanProduccion === true || verpproducciones === true) ? "" : "displaynone"}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => { toggle1('1'); }}
                                        >
                                            Planes de producción
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={verpplaneacion === true ? "" : "displaynone"/*pPlanProduccion === true ? "" :*/}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => { toggle1('2'); }}
                                        >
                                            Planeación Base
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={pPlanProduccion === true ? "" : "displaynone"}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => { toggle1('3'); }}
                                        >
                                            Almacén
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className="displaynone">
                                        <NavLink
                                            className={classnames({ active: activeTab === '4' })}
                                            onClick={() => { toggle1('4'); }}
                                        >
                                            {editar ? "Editar plan de producción" : "Nuevo plan de producción"}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className="displaynone" >
                                        <NavLink
                                            className={classnames({ active: activeTab === '5' })}
                                            onClick={() => { toggle1('5'); }}
                                        >
                                            Imprimir
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={ppproduccion === true ? "" : "displaynone"}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '6' })}
                                            onClick={() => { toggle1('6'); }}
                                        >
                                            Ecoat                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={ppproduccion === true ? "" : "displaynone "}>
                                        <NavLink
                                            className={classnames({ active: activeTab === '7' })}
                                            onClick={() => { toggle1('7'); }}
                                        >
                                            Powder coat
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={"displaynone"}> {/*className={pproduccionInspeccion === true ? "" : "displaynone"}*/}

                                        <NavLink
                                            className={classnames({ active: activeTab === '8' })}
                                            onClick={() => { toggle1('8'); }}
                                        >
                                            Inspección
                                        </NavLink>
                                    </NavItem>
                                    <NavItem className={"displaynone"} >{/*className={pproduccionRecuperacion === true ? "" : "displaynone"} */}
                                        <NavLink
                                            className={classnames({ active: activeTab === '9' })}
                                            onClick={() => { toggle1('9'); }}
                                        >
                                            Recuperación
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <PProduccionGen />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <PlaneacionB />
                                    </TabPane>
                                    <TabPane tabId="3">
                                        {activeTab === "3" && (
                                            <AlmacenProduccion />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="4">
                                    </TabPane>
                                    <TabPane tabId="5" >
                                    </TabPane>
                                    <TabPane tabId="6">
                                        {activeTab === '6' && (
                                            <Produccion />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="7">
                                        {activeTab === '7' && (
                                            <ProduccionPC />
                                        )}
                                    </TabPane>
                                    <TabPane tabId="8">
                                        {/*activeTab === "8" && (
                                            <Inspeccion />
                                        )*/}
                                    </TabPane>
                                    <TabPane tabId="9">
                                        {<Recuperacion />}
                                    </TabPane>
                                </TabContent>
                            </div>



                        </Fragment>
                    </div>
                </>
            )
            }
        </>
    )
};



export default PProduccion;